var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "signature-creation" }, [
    _c(
      "div",
      {
        class: {
          "alert alert-success": _vm.status == "success",
          "alert alert-danger": _vm.status == "danger",
        },
        attrs: { role: "alert" },
      },
      [_vm._v("\n              " + _vm._s(_vm.messageText) + "\n        ")]
    ),
    _vm._v(" "),
    _c("h4", [_vm._v("Start a new signature request")]),
    _vm._v(" "),
    _vm.quota && _vm.quota
      ? _c("p", [
          _vm._v("There are "),
          _c("strong", { domProps: { innerHTML: _vm._s(_vm.quota) } }),
          _vm._v(" API requests left on our plan. This will reset on the "),
          _c("strong", [_vm._v("26th")]),
          _vm._v(" of the month."),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.quota && _vm.quota == 0
      ? _c("p", [
          _vm._v(
            "Please contact the development team should this limit need adjusting."
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { class: { deactive: _vm.request || (_vm.quota && _vm.quota == 0) } },
      [
        _c("form", [
          _c("p", [_vm._v("Please select your recipient(s)")]),
          _vm._v(" "),
          _vm.article && _vm.article.authors && _vm.article.authors.length
            ? _c(
                "select",
                {
                  ref: "select",
                  staticClass: "form-control",
                  on: { change: _vm.addSignator },
                },
                [
                  _c("option", { attrs: { value: "" } }, [
                    _vm._v("Please select your recipients"),
                  ]),
                  _vm._v(" "),
                  _vm._l(
                    _vm.getAuthorsFiltered(),
                    function (author, authorIndex) {
                      return _c(
                        "option",
                        { domProps: { value: authorIndex } },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(author.first_name) +
                              " " +
                              _vm._s(author.last_name) +
                              "\n                    "
                          ),
                        ]
                      )
                    }
                  ),
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _c("p", { staticStyle: { "margin-top": "5px" } }, [
            _vm._v("or "),
            _c(
              "a",
              {
                attrs: { href: "javascript:;" },
                on: {
                  click: function ($event) {
                    return _vm.addAllSignators()
                  },
                },
              },
              [_vm._v("Select all")]
            ),
          ]),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _vm.signators && _vm.signators.length != 0
            ? _c(
                "div",
                [
                  _c("p", [_vm._v("Authors Selected")]),
                  _vm._v(" "),
                  _vm._l(_vm.signators, function (signator, signatorIndex) {
                    return _c("li", { staticStyle: { "list-style": "none" } }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(signator.email) +
                          " | "
                      ),
                      _c(
                        "a",
                        {
                          attrs: { href: "javascript:;" },
                          on: {
                            click: function ($event) {
                              return _vm.removeSignator(signatorIndex)
                            },
                          },
                        },
                        [_vm._v("Remove")]
                      ),
                    ])
                  }),
                  _vm._v(" "),
                  _c("hr"),
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "override-ltp-container" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.overrideLtp,
                  expression: "overrideLtp",
                },
              ],
              staticClass: "override-ltp-input",
              attrs: { type: "checkbox", name: "overrideLtp" },
              domProps: {
                checked: Array.isArray(_vm.overrideLtp)
                  ? _vm._i(_vm.overrideLtp, null) > -1
                  : _vm.overrideLtp,
              },
              on: {
                change: function ($event) {
                  var $$a = _vm.overrideLtp,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.overrideLtp = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.overrideLtp = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.overrideLtp = $$c
                  }
                },
              },
            }),
            _vm._v(" "),
            _c(
              "label",
              {
                staticClass: "override-ltp-label",
                attrs: { for: "overrideLtp" },
              },
              [
                _vm._v(
                  "\n                  Override already existing LTP request\n                "
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _vm._m(1),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Please note, if you do not wish to upload a custom document, the standard license form will be sent to all authors."
            ),
          ]),
          _vm._v(" "),
          _c("input", { attrs: { type: "file" }, on: { change: _vm.setFile } }),
        ]),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "signature-creation-submit",
            attrs: { disabled: _vm.isSubmitLoading },
            on: {
              click: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k(
                    $event.keyCode,
                    "preventDefault",
                    undefined,
                    $event.key,
                    undefined
                  )
                )
                  return null
                return _vm.createNew()
              },
            },
          },
          [
            _vm.isSubmitLoading
              ? _c("span", [
                  _c("i", { staticClass: "fa fa-spinner fa-spin" }),
                  _vm._v(
                    "License To Publish Form is generating…\n              "
                  ),
                ])
              : _c("span", [
                  _vm._v("\n                Submit\n              "),
                ]),
          ]
        ),
        _vm._v(" "),
        _c("br"),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v(
        "The default template for License to Publish signature requests is located "
      ),
      _c(
        "a",
        {
          attrs: {
            href: "https://jmir-assets.s3.ca-central-1.amazonaws.com/general/LicenseToPublish.docx",
          },
        },
        [_vm._v("here")]
      ),
      _vm._v("."),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v(
        "If you wish to upload a custom document, please see the documentation "
      ),
      _c(
        "a",
        {
          attrs: {
            href: "https://support.jmir.org/hc/en-us/articles/360042673872",
          },
        },
        [_vm._v("here")]
      ),
      _vm._v(" before doing so."),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }